import type { TOC } from '@ember/component/template-only';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    propertyName: string;
    name?: string;
  };
}

const ScaleSurveysFastEditionFormQuestionItemComponent: TOC<Signature> =
  <template>
    <div class='field'>

      <@form.Dropdown
        @labelName={{@name}}
        @propertyName={{@propertyName}}
        as |dropdown|
      >
        <dropdown.Item @value='Aucune difficulté (0)' @key='0' />
        <dropdown.Item @value='Légère difficulté (1)' @key='1' />
        <dropdown.Item @value='Difficulté modérée (2)' @key='2' />
        <dropdown.Item @value='Grave difficulté (3)' @key='3' />
      </@form.Dropdown>
    </div>
  </template>;

export default ScaleSurveysFastEditionFormQuestionItemComponent;
